
const digest = '65f025e43fdca5e99636bf6ec479ad69ac28787e3109d4ad09cb7e05a3304119';
const classes = {"wrapper":"_wrapper_sn5bz_1","imageWrapper":"_imageWrapper_sn5bz_8","content":"_content_sn5bz_18","badge":"_badge_sn5bz_22"};
const css = `._wrapper_sn5bz_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
}
._wrapper_sn5bz_1 ._imageWrapper_sn5bz_8 {
  margin: -40px -40px 0 -40px;
}
._wrapper_sn5bz_1 ._imageWrapper_sn5bz_8 img {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  width: 100%;
  aspect-ratio: 2/1;
  object-fit: cover;
}
._wrapper_sn5bz_1 ._content_sn5bz_18 {
  margin-top: 40px;
  flex-grow: 1;
}
._wrapper_sn5bz_1 ._badge_sn5bz_22 {
  background: rgba(33, 35, 87, 0.44);
  color: #ffffff;
  padding: 10px 20px;
  position: absolute;
  top: -60px;
  left: 0;
  border-radius: 30px;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  